import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import kz from "./locales/kz.json";

const LANGUAGE_COOKIE = "forpost_language";
const DEFAULT_LANGUAGE = "kz";
const supportedLanguages = ["ru", "kz", "en"];

export const languageOptions = [
  { code: "ru", label: "RU", name: "Русский" },
  { code: "kz", label: "KZ", name: "Қазақша" },
  { code: "en", label: "EN", name: "English" },
];

export function normalizeSiteLanguage(language) {
  const code = String(language || "").toLowerCase().split("-")[0];
  if (code === "kk") return "kz";
  return supportedLanguages.includes(code) ? code : DEFAULT_LANGUAGE;
}

function readLanguageCookie() {
  if (typeof document === "undefined") return null;
  const cookie = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${LANGUAGE_COOKIE}=`));
  return cookie ? decodeURIComponent(cookie.split("=").slice(1).join("=")) : null;
}

export function getInitialLanguage() {
  const stored = readLanguageCookie();
  return stored && supportedLanguages.includes(stored) ? stored : DEFAULT_LANGUAGE;
}

function updateDocumentLanguage(language) {
  if (typeof document === "undefined") return;
  document.documentElement.lang = language === "kz" ? "kk" : language;
  document.title = i18n.t("meta-title", { lng: language });
  const description = document.querySelector('meta[name="description"]');
  if (description) {
    description.setAttribute("content", i18n.t("meta-description", { lng: language }));
  }
}

const initialLanguage = getInitialLanguage();

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      kz: { translation: kz },
    },
    lng: initialLanguage,
    fallbackLng: "ru",
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
  });
}

export function setSiteLanguage(language) {
  const normalized = normalizeSiteLanguage(language);
  if (typeof document !== "undefined") {
    document.cookie = `${LANGUAGE_COOKIE}=${normalized}; Max-Age=31536000; Path=/; SameSite=Lax`;
  }
  updateDocumentLanguage(normalized);
  return i18n.changeLanguage(normalized);
}

updateDocumentLanguage(initialLanguage);

export default i18n;
